import { ConversationFormValues } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../app/middleware/twilio/actions/twilioActions';
import { actions as personalActions } from '../../settings/actions/personal';
import { composeEmailActions } from '../../shared/composeEmail/actions/composeEmailActions';
import { hasFeature } from '../../shared/featureFlag';
import { actions } from '../actions/conversation';
import ReplySection from '../components/ReplySection';
import { elevioActions } from '../components/integrations/elevio/src/elevio.actions';
import { getLatestFacebookConversation } from '../selectors';
import { getConversationFormName } from '../utils/conversationForm';

const mapStateToProps = (state) => {
  let canMakeOutBoundCall = true;
  const csid = state.conversation.metaConversation.conversation.id;
  const metaConversation = state.conversation.metaConversation;

  // We already have a active phone conversation in our load description. We cannot start a new one.
  const foundSpeakLoad =
    state.presence.presence.presence_status.load_descriptions.filter(
      (o) =>
        (o.conversation_channel === 'pstnphone' ||
          o.conversation_channel === 'callback') &&
        o.load_type !== 'acw' &&
        o.load_type !== 'nonlive',
    ).length;

  if (
    foundSpeakLoad > 0 ||
    state.telephony.isMicrophoneBlocked === true ||
    state.telephony.selectedFromNumber === null
  ) {
    canMakeOutBoundCall = false;
  }

  const form = getConversationFormName(csid);
  const formValues: ConversationFormValues = getFormValues(form)(state);

  return {
    channel: metaConversation.conversation.initial_channel,
    csid: csid,
    isAssignedToMe: metaConversation.isAssignedToMe,
    selectFromEmail: formValues?.fromEmail ?? null,
    live_assesment: metaConversation.conversation.live_assesment,
    makeCallAsyncStatus: state.twilio.meta.makeCall,
    canMakeOutBoundCall: canMakeOutBoundCall,
    telephonyFromNumber: state.telephony.selectedFromNumber,
    telephonyIsMicrophoneBlocked: state.telephony.isMicrophoneBlocked,
    isClosed: metaConversation.conversation.is_closed,
    isResolved: !!metaConversation.conversation.resolution?.resolvedAt,
    metaConversation: metaConversation,
    requester: metaConversation.requester,
    replyAreaHeight: state.settings.personal.replyAreaHeight,
    hasFFWriteHTMLEmail: hasFeature(state, 'write-html-email'),
    rewrittenHtmlEmailMessages: state.emailMessages.messages.filter(
      (m) => m.csid === csid,
    ),
    latestMessengerConversation: getLatestFacebookConversation(state),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    conversationClaim: bindActionToPromise(dispatch, actions.conversationClaim),
    telephonyMakeCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioMakeCall,
    ),
    composeEmailOpenModal: (payload) =>
      dispatch(composeEmailActions.composeEmailOpenModal(payload)),
    updateReplyAreaHeight: bindActionToPromise(
      dispatch,
      personalActions.personalReplyAreaHeight,
    ),
    updateCurrentTabStatus: (payload: { tabStatus: 'reply' | 'note' }) =>
      dispatch(elevioActions.smartReply.updateReplySectionTabStatus(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReplySection);
